import {
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import type { AiCampaignRecipientPreviewResponseDto } from '@/shared/api/ai-campaigns';

export function CampaignRecipientPreview({
  preview,
}: {
  preview: AiCampaignRecipientPreviewResponseDto | null;
}) {
  if (!preview) {
    return (
      <Typography variant="body2" color="text.secondary">
        Preview получателей еще не рассчитан.
      </Typography>
    );
  }

  if (preview.items.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        По текущему сегменту нет получателей.
      </Typography>
    );
  }

  return (
    <TableContainer sx={{ maxHeight: 260 }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Получатель</TableCell>
            <TableCell>Канал</TableCell>
            <TableCell>Протокол</TableCell>
            <TableCell>Контакты</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {preview.items.map((item) => (
            <TableRow key={`${item.channel_id}:${item.contact_id}`} hover>
              <TableCell>
                <Typography variant="body2" fontWeight={700}>
                  {[item.name, item.last_name].filter(Boolean).join(' ')}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {item.username || item.phone_number || item.contact_id}
                </Typography>
              </TableCell>
              <TableCell>{item.channel_id}</TableCell>
              <TableCell>{item.protocol || '—'}</TableCell>
              <TableCell>
                <Chip
                  size="small"
                  variant="outlined"
                  label={item.in_contact_list ? 'в списке' : 'не в списке'}
                  sx={{ borderRadius: 1 }}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
